import React, { FunctionComponent, memo } from 'react';
import Typography, { TypographyProps } from '@material-ui/core/Typography';
import usePriceFormatter from '../../react/usePriceFormatter';
import DotsLoader from '../dotsLoader/DotsLoader';

interface IPriceProps {
  price: number;
  currency: string;
  decimals?: number;
  language?: string;
  countryCode?: string;
  useCurrencySign?: boolean;
  loading?: boolean;
}

const Price: FunctionComponent<IPriceProps & TypographyProps & { component?: any }> = memo(
  ({ price, currency, decimals = 0, useCurrencySign = true, loading, ...rest }) => {
    const priceFormatter = usePriceFormatter({ currency, decimals, useCurrencySign });

    if (!currency) {
      return;
    }

    if (loading) {
      return <DotsLoader dataTest={'price:loader'} />;
    }

    return (
      <Typography {...rest} component="span">
        {priceFormatter.format(price)}
      </Typography>
    );
  },
);

export default Price;
